var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.formData.title,
            visible: _vm.drawer,
            direction: _vm.direction,
            modal: true,
            "show-close": true,
            "wrapper-closable": true,
            "append-to-body": true,
            "before-close": _vm.handleClose,
            size: _vm.formData.width,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "invoice-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c(
                "el-row",
                { staticClass: "invoice-header" },
                [
                  _c("el-col", { staticClass: "invoice-left" }, [
                    _c("div", { staticClass: "invoice-logo" }, [
                      _c("i", { staticClass: "icon iconfont iconfapiao" }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.drawer
                    ? _c("el-col", [
                        _c("div", { staticClass: "txt1" }, [
                          _vm._v(_vm._s(_vm.delData.title)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "txt2" }, [
                          _c("span", { staticClass: "title1" }, [
                            _vm._v("发票状态："),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "tab-btn",
                              class: _vm.getInvoiceColor(_vm.delData.status),
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.getInvoiceStatus(_vm.delData.status)
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("customer.invoicingpay")) + "："
                            ),
                          ]),
                          _c("span", { staticClass: "info2" }, [
                            _vm._v(_vm._s(_vm.delData.amount)),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              attrs: { type: "border-card", "tab-position": _vm.tabPosition },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.tabIndex,
                callback: function ($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "发票信息", name: "1" } }),
              _vm._v(" "),
              _c("el-tab-pane", { attrs: { label: "关联付款单", name: "2" } }),
              _vm._v(" "),
              _c("el-tab-pane", { attrs: { label: "操作记录", name: "3" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contract-body" },
            [
              _vm.tabIndex == 1
                ? _c(
                    "el-form",
                    {
                      staticClass: "invoice-body",
                      attrs: { "label-width": "110px" },
                    },
                    [
                      _c("div", { staticClass: "from-item-title mb15" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("setting.info.essentialinformation"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-box" }, [
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c("el-form-item", [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [_vm._v("客户名称：")]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.delData.client
                                      ? _vm.delData.client.name
                                      : "--"
                                  )
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.delData.treaty
                          ? _c(
                              "div",
                              { staticClass: "form-item" },
                              [
                                _c("el-form-item", [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("合同名称：")]
                                  ),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.delData.treaty
                                          ? _vm.delData.treaty.contract_name
                                          : "--"
                                      )
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c("el-form-item", [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [_vm._v("付款金额(元)：")]
                              ),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(_vm.delData.price))]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c("el-form-item", [
                              _c(
                                "span",
                                {
                                  staticClass: "item-label",
                                  attrs: { slot: "label" },
                                  slot: "label",
                                },
                                [_vm._v("发票类目：")]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.delData.category
                                      ? _vm.delData.category.name
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c("el-form-item", [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("customer.invoicingdate")) +
                                      "："
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(_vm.delData.bill_date))]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c("el-form-item", [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("public.remarks")) + "："
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(_vm._s(_vm.delData.mark || "--")),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "line" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "from-item-title mt15 mb15" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("customer.invoiceinformation"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-box" }, [
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c("el-form-item", [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("customer.invoicingpay")) +
                                      "："
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(_vm.delData.amount))]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c("el-form-item", [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("customer.headerinformation")
                                    ) + "："
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getInvoiceTitle(
                                      Number(_vm.delData.types)
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c("el-form-item", [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("customer.invoiceheader")) +
                                      "："
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(_vm.delData.title))]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.delData.types > 1
                          ? _c(
                              "div",
                              { staticClass: "form-item" },
                              [
                                _c("el-form-item", [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("customer.paytaxes")) +
                                          "："
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(_vm.delData.ident))]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.delData.types > 2
                          ? _c(
                              "div",
                              { staticClass: "form-item" },
                              [
                                _c("el-form-item", [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("地址、电话：")]
                                  ),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.delData.address) +
                                        " " +
                                        _vm._s(_vm.delData.tel)
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.delData.types > 2
                          ? _c(
                              "div",
                              { staticClass: "form-item" },
                              [
                                _c("el-form-item", [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("开户行及账号：")]
                                  ),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.delData.bank) +
                                        " " +
                                        _vm._s(_vm.delData.account)
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "line" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "from-item-title mt15 mb15" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("customer.mailinginformation"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-box" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-item" },
                            [
                              _c("el-form-item", [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [_vm._v("开票要求：")]
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.delData.collect_type == "mail"
                                          ? "电子"
                                          : "纸质"
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.delData.status !== 0 && _vm.delData.status !== -1
                            ? _c(
                                "div",
                                { staticClass: "form-item" },
                                [
                                  _c("el-form-item", [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [_vm._v("发送方式：")]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.delData.invoice_type == "mail"
                                              ? "邮箱"
                                              : "快递"
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.delData.status !== 0 && _vm.delData.status !== -1
                            ? [
                                _vm.delData.invoice_type !== "mail"
                                  ? _c(
                                      "div",
                                      { staticClass: "form-item" },
                                      [
                                        _c("el-form-item", [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("customer.contacts")
                                                ) + "："
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.delData.collect_name)
                                            ),
                                          ]),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.delData.invoice_type !== "mail"
                                  ? _c(
                                      "div",
                                      { staticClass: "form-item" },
                                      [
                                        _c("el-form-item", [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "customer.contactnumber"
                                                  )
                                                ) + "："
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.delData.collect_tel)
                                            ),
                                          ]),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-item" },
                                  [
                                    _vm.delData.invoice_type === "mail"
                                      ? _c("el-form-item", [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "customer.emailaddress"
                                                    )
                                                  ) +
                                                  " ："
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.delData.invoice_address
                                              )
                                            ),
                                          ]),
                                        ])
                                      : _c("el-form-item", [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label",
                                            },
                                            [_vm._v("邮箱信息：")]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.delData.invoice_address
                                              )
                                            ),
                                          ]),
                                        ]),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                _vm.delData.collect_type !== "mail"
                                  ? _c(
                                      "div",
                                      { staticClass: "form-item" },
                                      [
                                        _c("el-form-item", [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("customer.contacts")
                                                ) + "："
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.delData.collect_name)
                                            ),
                                          ]),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.delData.collect_type !== "mail"
                                  ? _c(
                                      "div",
                                      { staticClass: "form-item" },
                                      [
                                        _c("el-form-item", [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "customer.contactnumber"
                                                  )
                                                ) + "："
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.delData.collect_tel)
                                            ),
                                          ]),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-item" },
                                  [
                                    _vm.delData.collect_type === "mail"
                                      ? _c("el-form-item", [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "customer.emailaddress"
                                                    )
                                                  ) +
                                                  " ："
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.delData.collect_email)
                                            ),
                                          ]),
                                        ])
                                      : _c("el-form-item", [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label",
                                            },
                                            [_vm._v("邮箱信息：：")]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.delData.mail_address)
                                            ),
                                          ]),
                                        ]),
                                  ],
                                  1
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "line" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "from-item-title mt15 mb15" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("customer.billinginformation"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-box" }, [
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c("el-form-item", [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [_vm._v("开票结果：")]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getInvoiceStatus(_vm.delData.status)
                                  )
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.delData.status !== 0 && _vm.delData.status !== -1
                          ? _c(
                              "div",
                              { staticClass: "form-item" },
                              [
                                _c("el-form-item", [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("审核备注：")]
                                  ),
                                  _vm._v(" "),
                                  _vm.delData.status == -1
                                    ? _c("p", [_vm._v("--")])
                                    : _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.delData.remark || "--")
                                        ),
                                      ]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.delData.file && _vm.delData.file.length > 0
                          ? _c(
                              "div",
                              { staticClass: "form-item" },
                              [
                                _c("el-form-item", [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("开票凭证：")]
                                  ),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "item-img",
                                    attrs: {
                                      src: _vm.delData.file[0].thumb_dir,
                                      alt: "",
                                    },
                                  }),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.delData.status !== 0
                          ? _c(
                              "div",
                              { staticClass: "form-item" },
                              [
                                _c("el-form-item", [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("操作时间：")]
                                  ),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.delData.updated_at || "--")
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c("el-form-item", [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [_vm._v("申请人：")]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.delData.card
                                      ? _vm.delData.card.name
                                      : "--"
                                  )
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-item" },
                          [
                            _c("el-form-item", [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [_vm._v("申请时间：")]
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(_vm._s(_vm.delData.created_at || "--")),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.tabIndex == 2
                ? _c(
                    "div",
                    { staticClass: "invoice-body mr20" },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.tableData },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "bill_no",
                              label: "付款单号",
                              "min-width": "180",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "treaty.contract_name",
                              label: "合同名称",
                              "min-width": "150",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "types",
                              label: "业务类型",
                              "min-width": "200",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.types === 0
                                        ? _c("span", [_vm._v("回款记录")])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.types === 1
                                        ? _c("span", [
                                            _vm._v(
                                              "续费记录 - " +
                                                _vm._s(scope.row.renew.title)
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              348318987
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "num",
                              label: "付款金额(元)",
                              "min-width": "150",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "card.name",
                              label: "创建人",
                              "min-width": "90",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "created_at",
                              label: "创建时间",
                              "min-width": "180",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.tabIndex == 3
                ? _c(
                    "div",
                    { staticClass: "invoice-body1" },
                    [
                      _vm.recordList.length == 0
                        ? _c("div", { staticClass: "default" }, [
                            _c("img", {
                              staticClass: "img",
                              attrs: {
                                src: require("../../../../assets/images/defd.png"),
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text" }, [
                              _vm._v("暂无操作记录"),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.recordList.length !== 0
                        ? _c(
                            "el-steps",
                            {
                              staticClass: "set",
                              attrs: {
                                direction: "vertical",
                                space: "100",
                                active: 1,
                              },
                            },
                            _vm._l(_vm.recordList, function (item, index) {
                              return _c("el-step", { key: index }, [
                                _c(
                                  "div",
                                  { attrs: { slot: "icon" }, slot: "icon" },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "iconfont iconfapiaoxiangqing-caozuojilu",
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "description" },
                                    slot: "description",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "operationBox",
                                        class:
                                          item.operation_name == "申请开票"
                                            ? "removeBorderLine"
                                            : "",
                                      },
                                      [
                                        _c("div", { staticClass: "header" }, [
                                          _c("div", { staticClass: "left" }, [
                                            _vm._v(_vm._s(item.operation_name)),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "right" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(item.card.name) +
                                                  "\n                    "
                                              ),
                                              _c("el-divider", {
                                                attrs: {
                                                  direction: "vertical",
                                                },
                                              }),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(item.created_at) +
                                                  "\n                  "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        item.operation_name !== "申请开票"
                                          ? _c(
                                              "div",
                                              { staticClass: "footer" },
                                              [
                                                _c(
                                                  "el-form",
                                                  {
                                                    staticClass: "description",
                                                    attrs: {
                                                      "label-width": "110px",
                                                      "row-style": {
                                                        height: "32px",
                                                      },
                                                    },
                                                  },
                                                  _vm._l(
                                                    item.operation,
                                                    function (details, index) {
                                                      return _c(
                                                        "el-form-item",
                                                        {
                                                          key: index,
                                                          attrs: {
                                                            label: details.name,
                                                          },
                                                        },
                                                        [
                                                          details.name !==
                                                          "开票凭证："
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "content",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      details.val
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _c("img", {
                                                                staticClass:
                                                                  "item-img",
                                                                attrs: {
                                                                  src: details.val,
                                                                  alt: "",
                                                                },
                                                              }),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            }),
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.formData.follType &&
          _vm.formData.follType === "fd" &&
          _vm.delData.status === 0
            ? _c(
                "div",
                { staticClass: "button from-foot-btn fix btn-shadow" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.handleInvoicing },
                    },
                    [_vm._v("审核")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isImage
            ? _c("el-image-viewer", {
                attrs: {
                  "on-close": _vm.closeImageViewer,
                  "url-list": _vm.srcList,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("invoicing-dialog", {
        ref: "invoicingDialog",
        attrs: { config: _vm.invoicingDialog },
        on: { isOk: _vm.isOk },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }